import { render, staticRenderFns } from "./SetProofreader.vue?vue&type=template&id=5a16dba8&"
import script from "./SetProofreader.vue?vue&type=script&lang=ts&"
export * from "./SetProofreader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports